import { render, staticRenderFns } from "./AnnotationMark.vue?vue&type=template&id=7dc1a139&"
import script from "./AnnotationMark.vue?vue&type=script&lang=js&"
export * from "./AnnotationMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports